"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.MapModeInputEvents = void 0;
var tslib_1 = require("tslib");
var mobx_1 = require("mobx");
var services_1 = require("../../services");
var MapModeInputEvents = /** @class */ (function () {
    function MapModeInputEvents(page) {
        this.page = page;
    }
    MapModeInputEvents.prototype.init = function () {
        this.eventContext = services_1.Services.Input.getContext();
        this.eventContext.on(this.eventContext.Code.KeyL, this.toggleLabels, {
            modifiers: {
                ctrl: true
            }
        });
    };
    MapModeInputEvents.prototype.toggleLabels = function (evt) {
        evt.event.preventDefault();
        this.page.controller.map.overlay.toggleViewTitles();
    };
    MapModeInputEvents.prototype.destroy = function () {
        if (this.eventContext != null) {
            this.eventContext.destroy();
            this.eventContext = null;
        }
    };
    tslib_1.__decorate([
        mobx_1.action.bound
    ], MapModeInputEvents.prototype, "toggleLabels", null);
    return MapModeInputEvents;
}());
exports.MapModeInputEvents = MapModeInputEvents;
//# sourceMappingURL=mm.events.js.map